export const CONNECT_USER_TO_ROOM = 'CONNECT_USER_TO_ROOM'
export const DISCONNECT_USER_TO_ROOM = 'DISCONNECT_USER_TO_ROOM'
export const SET_ROOM_NETWORK = 'SET_ROOM_NETWORK'
export const SET_LOCAL_AUDIO_TRACK = 'SET_LOCAL_AUDIO_TRACK'
export const SET_LOCAL_VIDEO_TRACK = 'SET_LOCAL_VIDEO_TRACK'
export const SET_REMOTE_TRACK_DISABLED = 'SET_REMOTE_TRACK_DISABLED'
export const SET_REMOTE_TRACK_ENABLED = 'SET_REMOTE_TRACK_ENABLED'
